import NotificationAlert from 'molecules/NotificationAlert';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useUserAuth } from 'utils/hooks/useUserAuth';

const NotificationAlertImpersonate = () => {
  const authDetails = useUserAuth();
  const router = useRouter();

  const [showNotification, setShowNotification] = useState(false);
  const [modeIsOff, setModeIsOff] = useState(false);

  useEffect(() => {
    if (authDetails?.isImpersonated) return;
    const storedImpersonatedMode = localStorage.getItem('impersonatedMode');
    if (router?.query?.impersonated === 'false' && storedImpersonatedMode !== null) {
      localStorage.removeItem('impersonatedMode');
      setShowNotification(true);
      setModeIsOff(true);
    }
  }, [authDetails?.isImpersonated, router?.query?.impersonated]);

  useEffect(() => {
    if (!authDetails?.isImpersonated) return;
    const storedImpersonatedMode = localStorage.getItem('impersonatedMode');
    if (storedImpersonatedMode && JSON.parse(storedImpersonatedMode)) return;
    setShowNotification(true);
    localStorage.setItem('impersonatedMode', 'true');
  }, [router?.query?.impersonated, authDetails?.isImpersonated]);

  return (
    <NotificationAlert open={showNotification} severity="success">
      {modeIsOff ? 'You are not in "Impersonating mode"' : 'You are in "Impersonating mode"'}
    </NotificationAlert>
  );
};

export default NotificationAlertImpersonate;
